import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { IoIosArrowRoundBack } from "react-icons/io";

import PageHeader from "../../../core/common/crmComponents/PageHeader";
import ChangePassword from "../../auth/changePassword";
import moment from "moment";
import { useSelector } from "react-redux";
import { convertToUTCString } from "../../../utils/helpers/helper";

const Security = () => {
  const navigate = useNavigate();
  const { user } = useSelector((state) => state?.auth);

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="row">
            <div className="col-md-12">
              <PageHeader pageName="Security">
                <button
                  className="p-2 btn btn-outline-none"
                  onClick={() => navigate(-1)}
                >
                  <IoIosArrowRoundBack className="d-inline" size={20} />
                </button>
              </PageHeader>
              <div className="row">
                <div className="col-lg-12">
                  <div className="card">
                    <div className="card-body pb-0">
                      <h4 className="fw-semibold mb-3">Security Settings</h4>
                      <div className="row">
                        <div className="col-lg-4 col-md-6 d-flex">
                          <div className="card border shadow-none flex-fill mb-3">
                            <div className="card-body d-flex justify-content-between flex-column">
                              <div className="mb-3">
                                <h5 className="">Password</h5>
                                <p>
                                  <span className="fw-semibold me-2">
                                    Last Changed:
                                  </span>
                                  {user?.passwordChangedAt
                                    ? convertToUTCString(
                                        user?.passwordChangedAt
                                      )
                                    : "N/A"}
                                </p>
                              </div>
                              <div>
                                <Link
                                  to="#"
                                  className="btn btn-light"
                                  data-bs-toggle="modal"
                                  data-bs-target="#change_password"
                                >
                                  Change Password
                                </Link>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ChangePassword />
    </div>
  );
};

export default Security;
